import { CommonFormType } from '../types';

// 榜单页通用下载接口，目前应用于pc、console、combine的所有榜单页下载
export const TOPCHARTS_COMMON_DOWNLOAD_API = '/api/v1/intelligence_pc/topChartPcConsoleMetricExcel';
// pc&console榜单下载新使用接口,预处理统一接口
export const TOPCHARTS_COMMON_DOWNLOAD_API_PC_CONSOLE = '/api/v1/intelligence_pc/topcharts_list';

// 游戏详情页Stats、Countries页签下载接口（combine）
export const DETAILS_STATS_COUNTRIES_COMMON_DOWNLOAD_API =
  '/api/v1/intelligence_pc/pcConsoleGame/detail/stats/metrics/pc_console_downloads_excel';

// 下载增加发行开发商信息（Basic Information）
export const publisherCheckboxList: CommonFormType = {
  label: 'dbi_label_basic_info',
  type: 'checkbox',
  field: 'data_sources',
  defaultValue: {
    company_show: false,
    genre_show: false,
    release_date_show: false,
    region_show: false,
    steam_id_show: false,
    game_engine_show: false,
  },
  options: [
    { label: 'dbi_label_company_info', value: 'company_show' },
    { label: 'dbi_label_genre', value: 'genre_show' },
    { label: 'dbi_release_date', value: 'release_date_show' },
    { label: 'dbi_area_region', value: 'region_show' },
    { label: 'dbi_steam_id', value: 'steam_id_show' },
    { label: 'dbi_top_game_engine', value: 'game_engine_show' },
  ],
};

// 下载增加发行开发商信息（Basic Information），-NoRegion
export const publisherCheckboxListNoRegion: CommonFormType = {
  label: 'dbi_label_basic_info',
  type: 'checkbox',
  field: 'data_sources',
  defaultValue: {
    company_show: false,
    genre_show: false,
    release_date_show: false,
    steam_id_show: false,
    game_engine_show: false,
  },
  options: [
    { label: 'dbi_label_company_info', value: 'company_show' },
    { label: 'dbi_label_genre', value: 'genre_show' },
    { label: 'dbi_release_date', value: 'release_date_show' },
    { label: 'dbi_steam_id', value: 'steam_id_show' },
    { label: 'dbi_top_game_engine', value: 'game_engine_show' },
  ],
};

// 下载增加发行开发商信息（Basic Information）--新规则
export const newPublisherCheckboxList: CommonFormType = {
  label: 'dbi_label_basic_info',
  type: 'checkbox',
  field: 'data_sources',
  defaultValue: {
    company_show: false,
    genre_show: false,
    release_date_show: false,
    region_show: false,
    game_engine_show: false,
  },
  options: [
    { label: 'dbi_label_company_info', value: 'company_show' },
    { label: 'dbi_label_genre', value: 'genre_show' },
    { label: 'dbi_release_date', value: 'release_date_show' },
    // { label: 'dbi_area_region', value: 'region_show' },
    { label: 'dbi_top_game_engine', value: 'game_engine_show' },
  ],
};

// 下载增加发行开发商信息（Basic Information）--新规则
export const storeRankTopRankingsFormItem: CommonFormType = {
  label: 'dbi_label_rankings',
  type: 'checkboxGroup',
  field: 'sources',
  showBatchOperation: true,
  defaultValue: [],
  options: [],
};

export const storeRankTopBasicInfoFormItem: CommonFormType = {
  label: 'dbi_label_basic_info_optional',
  type: 'checkbox',
  field: 'data_sources',
  defaultValue: {
    release_date_show: false,
    genre_show: false,
  },
  options: [
    { label: 'dbi_release_date', value: 'release_date_show' },
    { label: 'dbi_label_genre', value: 'genre_show' },
  ],
};

export const newPublisherCheckboxListMobileUpcoming: CommonFormType = {
  label: 'dbi_label_basic_info',
  type: 'checkbox',
  field: 'data_sources',
  defaultValue: {
    company_show: false,
    genre_show: false,
    release_date_show: true,
    region_show: false,
  },
  options: [
    { label: 'dbi_label_company_info', value: 'company_show' },
    { label: 'dbi_label_genre', value: 'genre_show' },
    // { label: 'dbi_release_date', value: 'release_date_show' },
    // { label: 'dbi_area_region', value: 'region_show' },
  ],
};
